import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import Img from "gatsby-image/withIEPolyfill"

import { ClickableImageWrapper } from "../Styled/Image"

export const GatsbyImageComponent = ({
  alt,
  onClick,
  location,
  ratio,
  image,
  fullHeight,
  imageLink,
  styled,
  objectFit,
  background,
  staticImage = false,
  loading,
}) => {
  const isGif = image?.asset?.mimeType === "image/gif" ? true : false
  const newImage = isGif ? { ...image, srcSetWebp: null, srcWebp: null } : image
  newImage?.src == undefined && image?.images?.fallback ? { ...newImage, ...(newImage.src = image.images.fallback.src) } : image
  const ratioAaspect = ratio ? ratio?.split(`/`)[0] / ratio?.split(`/`)[1] : null

  return (
    <ClickableImageWrapper enabled={onClick && imageLink} onClick={onClick && imageLink ? () => onClick(imageLink) : null} background={background}>
      {staticImage ? (
        <div
          style={{
            backgroundImage: `url(${newImage.src})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
            height: fullHeight ? "100%" : "auto",
          }}
        />
      ) : styled ? (
        <Img
          alt={alt}
          fluid={ratio ? { ...newImage, aspectRatio: ratioAaspect } : newImage}
          style={fullHeight ? { height: "100%" } : null}
          imgStyle={{ width: "70%", height: "70%", top: "auto", left: "auto", bottom: "0px", right: "0px" }}
          objectPosition={`bottom`}
          objectFit={objectFit ? objectFit : `cover`}
        />
      ) : (newImage?._type == "image" || newImage?._type == "customImage") && ratioAaspect != 1 && location != "menu" ? (
        <GatsbyImage alt={alt} image={newImage} />
      ) : location == "menu" ? (
        <Img
          alt={alt}
          fluid={ratio ? { ...newImage, aspectRatio: ratioAaspect } : newImage}
          style={fullHeight ? { height: "100%" } : null}
          objectFit={objectFit ? objectFit : `cover`}
          loading={loading ? loading : "lazy"}
        />
      ) : (
        <Img
          alt={alt}
          fluid={ratio ? { ...newImage, aspectRatio: ratioAaspect } : newImage}
          style={fullHeight ? { height: "100%" } : null}
          objectFit={objectFit ? objectFit : `cover`}
          loading={loading ? loading : "lazy"}
        />
      )}
    </ClickableImageWrapper>
  )
}
